export enum WrapperTags {
  ModalProgramHeader = 'modalProgramHeader',
  ModalProgramContent = 'modalProgramContent',
  MoneyIncentiveCardWrapper = 'moneyIncentiveCardWrapper',
  MoneyIncentiveCardImageWrapper = 'moneyIncentiveCardImageWrapper',
  RequestPasswordModalWrapper = 'requestPasswordModalWrapper',
  UploadButtonWrapper = 'uploadButtonWrapper',
  ProgramStatusCardWrapper = 'programStatusCardWrapper',
}
